import { useEffect, useRef } from 'react';
import type { RefObject } from 'react';

const CONFETTI_COLORS = ['#2D5F4F', '#F4A574', '#7AB8E3', '#F2B5C9', '#F4D06F'];
const CONFETTI_DELAY_MS = 680;
const NUM_PARTICLES = 42;

export const useConfettiBurst = (): RefObject<HTMLDivElement | null> => {
	const hostRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const particleTimers: ReturnType<typeof setTimeout>[] = [];
		const burst = setTimeout(() => {
			const host = hostRef.current;
			if (!host) return;
			for (let i = 0; i < NUM_PARTICLES; i++) {
				const p = document.createElement('div');
				p.className = 'onb-confetti-particle';
				p.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
				const angle = Math.random() * Math.PI * 2;
				const distance = 60 + Math.random() * 110;
				const tx = Math.cos(angle) * distance;
				const tyUp = Math.sin(angle) * distance - 20;
				const tyDown = tyUp + 140 + Math.random() * 80;
				const rot = (Math.random() - 0.5) * 720;
				const w = 6 + Math.random() * 5;
				const h = 8 + Math.random() * 8;
				const delay = Math.random() * 80;
				p.style.width = `${w}px`;
				p.style.height = `${h}px`;
				p.style.setProperty('--tx', `${tx}px`);
				p.style.setProperty('--ty-up', `${tyUp}px`);
				p.style.setProperty('--ty-down', `${tyDown}px`);
				p.style.setProperty('--rot', `${rot}deg`);
				p.style.animationDelay = `${delay}ms`;
				host.appendChild(p);
				particleTimers.push(
					setTimeout(() => {
						p.remove();
					}, 1400 + delay),
				);
			}
		}, CONFETTI_DELAY_MS);

		return () => {
			clearTimeout(burst);
			particleTimers.forEach(clearTimeout);
		};
	}, []);

	return hostRef;
};
